import { tool } from "ai";
import { z } from "zod";
import { PROXY_URL, getTodayDate } from "./shared";

export default tool({
  description: "Retrieves sales goals in timeseries.",
  parameters: z.object({
    from: z.string().describe("Start date in YYYY-MM-DD format"),
    to: z
      .string()
      .describe("Ending date in YYYY-MM-DD format")
      .default(getTodayDate()),
    country: z.string().describe("Two letter country code").default("NL"),
    timeframe: z.enum(["year", "month", "week"]).default("year"),
    channel: z
      .enum(["Remote", "Online", "Store", ""])
      .describe(
        "Sales channel. If the user does not mention any sales channel then it is omitted"
      )
      .optional(),
  }),
  execute: async ({ from, to, timeframe, country, channel }) => {
    console.log("::::EXECUTING", { from, to, timeframe, country, channel });
    const searchParams = new URLSearchParams({
      from,
      to,
      timeframe,
      select: `created_net_revenue_goal.sum()${
        channel ? `,sales_channel` : ""
      }`,
      identifier: `country.eq('${country}')`,
    }).toString();
    console.log(":::::", { searchParams });
    const url = `${PROXY_URL}/ts-sales-actuals-api/v1/goals?${searchParams}`;
    const results = await fetch(url);
    const json = await results.json();
    return json;
  },
});
